import { lazy } from "react";

const ActivatedPage = lazy(() => import("@pages/activated/ActivatedPage"));
const ActivatePage = lazy(() => import("@pages/activated/ActivatePage"));
const TeamInvitePage = lazy(() => import("@pages/activated/TeamInvitePage"));

export const activatedRoutes = [
  { path: "/activated/:id", element: <ActivatedPage /> },
  { path: "/activate", element: <ActivatePage /> },
  { path: "/team-invite/:token", element: <TeamInvitePage /> },
];
